import React, { useState, useEffect } from "react";
import './Admin.css';
import AdminDataService from "../../services/admin.service";
import Button from "react-bootstrap/Button";
import UploadDataService from "../../services/upload.service";
import SignUpDataService from "../../services/signup.service";
import Updated from "../Messages/Updated";
import { Row, Col } from "reactstrap";
import Modal from 'react-bootstrap/Modal';
  class AdminUser extends React.Component{

    constructor(props) {
      super(props);
      const isLoggedIn = window.localStorage.getItem("userid") ? true : false;
      let userid = 0;
    
      if(isLoggedIn)
      {
      userid = window.localStorage.getItem("userid");
  
      }
      this.state = {
        list: [],
        activeUser: {},
        downloads: [],
        imgCount: 0,
        modalShow : false,
        displayImage : 'cupid.png',
        stage: 0

  
      };
    }

 
      async onDeleteImage(e, value)
      {
      e.preventDefault();
    
        this.setState({ stage: 0 });
    
       await UploadDataService.delete(parseInt(e.target.name))
        .then(res => {
          if(res.data != '')
          {

            UploadDataService.download(value)
            .then(response => {
                if(response.data == '')
                {
                  //if count is zero , reset upload flag
            let data = {
              upload: 0
            };
            SignUpDataService.update(value, data)
            .then(res => {
              
            });

                }

            });

    
          this.setState({ stage: 1 });
          
       
          }
        });
    
        
    }
    closeDetails(name, value) {
      this.setState({activeUser: 0 });
      this.setState({downloads: [] });
      this.setState({stage: 0 });
    };


     openDetails(name, value) {
      
      AdminDataService.get(value)
      .then(res => {
        if(res.data != '')
        {

          var data = {
            id: res.data.id
          }
         
          this.setState({activeUser: data});

          this.setState({
            downloads: []
          });
      
          let arrayList = [];
          UploadDataService.download(res.data.id)
          .then(response => {
            if(response.data != '')
              {
                this.setState({imgCount : response.data.length})
      
                response.data.map(val  => {
      
                  let data = {
                    id: val.id,
                    fileLink: val.fileLink,
                    userid: val.userid,
                    filename: val.filename
      
                  }
      
                  arrayList.push(data);
      
                }
                  
                  );
      
                 
      
                this.setState({
                  downloads: [
                  arrayList
                  ]
                });
      
              }
      
          })
          .catch(e => {
            console.log(e);
          });



        }

      });
     
    }

    handleShow = (name) => {
      this.setState({modalShow: true});
      this.setState({displayImage: name});
    }
  
    handleClose = () => {
      this.setState({modalShow: false});
    }
  

    async componentDidMount() {
    
      AdminDataService.getAll()
      .then(res => {
          if(res.data != '')
          {
            res.data.map(res1 => {

              var data = {
                id: res1.id,
                name: res1.name,
                age: res1.age,
                email: res1.email,
                active: res1.active ? "Active" : "Not Active"
  
  
            }
            this.setState({
              list: [
              ...this.state.list,
              data
              ]
            }); 
            });

            

        }
          
      })

     

    }

    render(){
      return (
    <div className="row col-md-12">
      <Row>

<Modal show={this.state.modalShow} onHide={this.handleClose}>
  <Modal.Header closeButton>
  <Button block="true"  variant="secondary" onClick={this.handleClose}>
      Close
    </Button>
  </Modal.Header>
  <Modal.Body><img width="400" src={this.state.displayImage} /></Modal.Body>
  <Modal.Footer>
   
  </Modal.Footer>
</Modal>
</Row>
        {
          this.state.list != [] && this.state.list.length > 0 ?
            <div>
              <Row className="img-space row col-md-12">
{this.state.stage == 1 ? <Updated Color={'accept-color'}  Message={'Succesfully Deleted image'}/> : ''}

       {this.state.downloads.map(dat => dat.map(fat => (
            <div key="table_users" className="col-md-3">
              <Col  md="col-md-12">  
         <img width="150" onClick={() => this.handleShow(fat.fileLink)} src={fat.fileLink} key={fat.id}  /> <br/>
          <label>{fat.filename}</label><br/>
          <button block="true"  name={fat.id} onClick={e => this.onDeleteImage(e, this.state.activeUser.id)} type="submit" className="btn btn-danger">
          Delete Image
        </button>
   
        </Col>
        </div>
       )
       ))
     }

    </Row>
            <table responsive className="table">
            <thead>
                <tr><td>Name</td>
                <td>Age</td>
                <td>Status</td>
                <td>Email</td>
                <td></td>
                <td></td>
                </tr>
            </thead>
            <tbody>
            {
            this.state.list.map((user,index) => (
                        <tr key={index + "table_user_data"} >
                        <td key={index + "_a"} className="table-text-color">{user.name}</td>  
                        <td key={index + "_b"} className="table-text-color">{user.age}</td>  
                        <td key={index + "_c"} className="table-text-color">{user.active}</td>  
                        <td key={index + "_z"} className="table-text-color">{user.email}</td>  
                        <td>
                        <Button block="true"  style={{cursor:'pointer'}}  onClick={e => this.openDetails(e.target.value, user.id)} className="btn btn-success">Details</Button>
                        </td>
                        <td>
                        <Button block="true"  style={{cursor:'pointer'}}  onClick={e => this.closeDetails(e.target.value, user.id)} className="btn btn-success">Close Details</Button>
                        </td>
                          {

                            this.state.activeUser != {} ? <td>



                            </td> : ''
                          }
                        

                      </tr>
                                   
                    ))
            }
            </tbody>
            </table>
            </div>
         
          : <span className="table-text-color">No Users found</span>

        }
    </div>
    
      )
      }
}



export default AdminUser;